import { isEditable } from "@testing-library/user-event/dist/utils";
import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import CustomCSSTransition from "./CustomCSSTransition";

const Select = ({ options, selectedClasses, editable = false }) => {
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(options[0]);
  const [inputValue, setInputValue] = useState(selected.text);

  const classes = Object.values({
    initialClasses:
      "rounded-lg flex justify-between items-center shrink-0 cursor-pointer w-full bg-white border-2 border-[#e7e7e7]",
    fontWeight: selectedClasses.fontWeight,
    fontSize: selectedClasses.fontSize,
    padding: selectedClasses.padding,
  }).join(" ");

  const handleOpen = (value) => {
    setOpen((prevValue) => (value ? value : !prevValue));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSelected(
      setSelected(options.filter((option) => option.text === inputValue))
    );
    setInputValue(selected.text);
  };

  const handleSelect = (event) => {
    handleOpen(false);
    if (editable) {
      setInputValue(event.target.innerText);
      setSelected(options.filter((option) => option.text === inputValue));
    } else {
      console.log(selected);
      setSelected(
        ...options.filter((option) => option.text === event.target.innerText)
      );
    }
    // handleOpen(false);
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
    // setFilteredOptions(
    //   options.filter((option) =>
    //     option.text.toLowerCase().includes(inputValue.toLowerCase())
    //   )
    // );
    filterOptions();
  };

  const filterOptions = () => {
    if (inputValue.length === 0) setFilteredOptions(options);
    else {
      setFilteredOptions(
        options.filter((option) =>
          option.text.toLowerCase().includes(inputValue.toLowerCase())
        )
      );
    }
  };

  return (
    <div className="">
      <div className="select_wrapper  items-center relative">
        {editable ? (
          <form className="w-full" onSubmit={(event) => handleSubmit(event)}>
            <div className={`selected relative overflow-hidden`}>
              <input
                className={`pr-4 text-black ${classes}`}
                type={"text"}
                value={inputValue}
                onChange={(event) => handleChange(event)}
                // onBlur={() => handleOpen(false)}
                // onFocus={() => handleOpen(true)}
                onClick={() => handleOpen(true)}
              />
              <span
                onClick={(event) => {
                  handleOpen();
                  event.stopPropagation();
                }}
                className="flex justify-center items-center absolute h-full right-0 top-1/2 -translate-y-1/2 p-3 cursor-pointer"
              >
                <IoIosArrowDown className="w-4 h-4" />
              </span>
            </div>
          </form>
        ) : (
          <div>
            <div
              className={`selected relative ${classes}`}
              onClick={() => handleOpen()}
            >
              <span className={`pr-4 text-black `}>{selected.text}</span>
              <span className="">
                <IoIosArrowDown className="w-4 h-4" />
              </span>
            </div>
          </div>
        )}

        <CustomCSSTransition inValue={open}>
          <div
            role={"listbox"}
            className={`options w-full absolute text-sm font-normal top-full bg-white rounded-lg right-0 border-2 border-[#e7e7e7] transition-all duration-300 shadow-lg`}
          >
            <ul className="flex flex-col p-4 max-h-72 overflow-auto">
              {filteredOptions.map((option, index) => {
                return (
                  <li
                    key={index}
                    id="sort-by"
                    aria-selected={option.id === selected.id}
                    data-option-id={option.id}
                    data-sth="sth"
                    className="mb-4 last:mb-0 cursor-pointer hover:text-[#e66553] transition-all duration-200 shrink-0"
                    onClick={(event) => handleSelect(event)}
                  >
                    {option.text}
                  </li>
                );
              })}
            </ul>
          </div>
        </CustomCSSTransition>
      </div>
    </div>
  );
};

Select.defaultProps = {
  selectedClasses: {
    fontSize: "text-[13px]",
    fontWeight: "font-semibold",
    padding: "py-3 px-4",
  },
};

export default Select;
